module.exports = __webpack_public_path__ + "img/fuwuxiangmu_jpg2_fwsxq.86b8f179.png";